import React, { Component } from 'react';
import CelaneseAPI from '../../services';
import { Modal, InputNumber, Form, Button, message } from 'antd';
import { Combobox } from 'react-widgets';
import 'react-widgets/dist/css/react-widgets.css';
import PropTypes from 'prop-types';
import './epd.css';
import { connect } from 'react-redux';
import { getEpdData } from './../../actions/index';
import Translation from '../../Translation';
import { utils } from '../../config';

const FormItem = Form.Item;
/**
 *
 * class for calculation of slope and intercept
 * 
 * @class Epd 
 * @extends {Component}
 */
class Epd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lowepdOrg: 0,
            highepdOrg: 0,
            lowepdMeasured: 0,
            highepdMeasured: 0,
            filterlength: 0,
            slope: 0,
            intercept: 0,
            name: '',
            errorMessage: '',
            invalid: '',
            data: [],
            value: [],
        };
        this.calcSlopeIntercept = this.calcSlopeIntercept.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    componentWillMount() {
        this.assignData(this.props);
    }
    componentWillReceiveProps(nextProps) {
        this.assignData(nextProps);
    }
    /**
     *
     *assignData function is for getting the epd data from redux/store
     * @param {object|array} nextProps
     * @memberof Epd
     */
    assignData(nextProps) {
        if (nextProps.epdData && nextProps.epdData.length && nextProps.prefData) {
            let data = nextProps.epdData;
            this.setState({
                data: data
            });
        }
    }

    /**
     *success function is for showing success message when epd is created/updated successfully
     *
     * @memberof Epd
     */
    success = () => {
        message.success(utils.getTranslationText('msg_epd_success_created','EPD Bias successfully created.'), 1);
    };
    /**
     *error function is for showing error messsage when epd bias is not created
     *
     * @memberof Epd
     */
    error = () => {
        message.error(utils.getTranslationText('msg_create_epd_bias','Unable to create EPD Bias'), 2);
    };
    /**
     *warning function is for showing error message when validating the input field 
     *
     * @memberof Epd
     */
    warning = () => {
        message.warning(utils.getTranslationText('err_msg_value_cannot_be_zero','Values cannot be zero.'), 2);
    };
    /**
     *information function is for showing error message when validating the input field 
     *
     * @memberof Epd
     */
    information = () => {
        message.info(utils.getTranslationText('msg_values_cannot_be_same','Values cannot be same.'), 2);
    };
    /**
     *
     *warningSameName function is for showing error message when user tries to update epd not created by him
     * @memberof Epd
     */
    warningSameName = () => {
        message.warning(utils.getTranslationText('msg_you_cannot_update_epd','You cannot update the Epd that is not created by you'), 2);
    }

    /**
     *handleClear function is for clearing the input fields.
     *
     * @memberof Epd
     */
    handleClear() {
        this.props.form.resetFields();
        this.setState({
            slope: 0,
            intercept: 0,
            name: '',
        });
        this.props.showEpdScreen(false);
    }
    reset = (e) => {
        e.preventDefault();
        this.props.form.resetFields();
        this.setState({
            slope: 0,
            intercept: 0,
            name: '',
        });
    }
    /**
     *
     * validateInputFields is for validation of input fields.
     * @memberof Epd
     */
    validateInputFields = (rule, value, callback) => {
        if (value === 0) {
            callback(<Translation labelName="err_msg_value_cannot_be_zero" defaultText="value cannot be zero"/>);
        }
        else if (value < 0) {
            callback(<Translation labelName="msg_value_cannot_negative" defaultText="value cannot be negative!"/>);
        }
        else if (value && typeof value === 'string') {
            callback(<Translation labelName="msg_enter_number" defaultText="Enter a number"/>);
        }
        else {
            callback();
        }
    }
    /**
     *
     *  handleSubmit function validates the input field and after validating adds new epd or update the existing one
     * 
     * @param {*} e here e is an event passed as input
     * @memberof Epd
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let obj = {
                    'slope': this.state.slope,
                    'intercept': this.state.intercept,
                    'name': this.state.name
                };
                let epdObj = Object.assign(obj, values);
                CelaneseAPI.post('/epdbias', epdObj).then((res) => {
                    if (res.error) {
                        if (res.error === <Translation labelName="msg_epd_basic_already_exits" defaultText="You cant update this epd bais name already exists"/>) {
                            this.warningSameName();
                        }
                        else {
                            this.error();
                        }
                        return;
                    }
                    else {
                        this.success();
                        getEpdData().then(res => {
                            return res;
                        })
                    }
                    this.handleClear();
                }).catch(() => {
                    this.error();
                });
            }
            else {
                this.error();
            }
        });
    }

    /**
     *
     *handleFilter function is called when epd bias name is typed or selected in dropdown box. It filters and
     * populates the form if the name matches with existing epd
     * 
     * @memberof Epd
     */
    handleFilter() {
        let data = this.state.data;
        let result = data.find(element => element.name === this.state.name);
        if (result) {
            this.props.form.setFieldsValue({
                lowepdOrg: result.lowepdOrg,
                highepdOrg: result.highepdOrg,
                lowepdMeasured: result.lowepdMeasured,
                highepdMeasured: result.highepdMeasured,
                filterlength: result.filterlength
            });
            this.setState({
                slope: result.slope,
                intercept: result.intercept
            });
        }
    }

    /**
     *
     *calcSlopeIntercept function calculates the slope and intercept from the input field values
     * @memberof Epd
     */
    calcSlopeIntercept = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    filterlength: values.filterlength,
                    lowepdOrg: values.lowepdOrg,
                    highepdOrg: values.highepdOrg,
                    lowepdMeasured: values.lowepdMeasured,
                    highepdMeasured: values.highepdMeasured,

                }, () => {
                    let filterLen = this.state.filterlength;
                    let highepd = parseFloat(this.state.highepdOrg);
                    let highepdmeasured = parseFloat(this.state.highepdMeasured);
                    let lowepd = parseFloat(this.state.lowepdOrg);
                    let lowepdmeasured = parseFloat(this.state.lowepdMeasured);
                    let highlow = (parseFloat(highepd) - parseFloat(lowepd));

                    if (filterLen === 0) {
                        this.warning();
                    }
                    else if (highlow === 0) {
                        this.information();
                    }
                    else {
                        let slope = (highepdmeasured - lowepdmeasured) / highlow;
                        let intercept = (lowepdmeasured - slope * lowepd) / filterLen;
                        let roundslope = parseFloat(slope.toFixed(3));
                        let interceptround = parseFloat(intercept.toFixed(3));
                        this.setState({
                            slope: roundslope,
                            intercept: interceptround
                        });
                    }
                });
            }
        });

    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div className="epd-bias-wrapper">
                <Modal title={<Translation labelName="lbl_epd_bias" defaultText="EPD Bias"/>}
                    centered
                    width={500}
                    style={{ top: 20 }}
                    //okText="Save"
                    //cancelText="Reset"
                    maskClosable={true}
                    //okButtonProps={
                    //{loading: this.state.isSaving}
                    //}
                    footer={null}
                    visible={this.props.isEpdVisible}
                    //onOk={(e) => this.handleSubmit(e)}
                    onCancel={() => this.handleClear()}
                    className="epd">
                    <div className="ant-layout-content">
                        <div className='epd-container'>
                            {/* <a href='/help/html/Pressure_Drop_Measurement_Bias.htm' title="Help" target="_blank" className="help-section">
                                <img
                                    src="./images/help-inverse-black.svg"
                                    alt="help"
                                    className="help-icon" />
                            </a> */}
                            <Form onSubmit={(e) => this.handleSubmit(e)}>
                                <div>
                                    <label className="epd-container__select--label bold-label"><Translation labelName="lbl_name" defaultText="Name"/>:</label>
                                    <Combobox
                                        caseSensitive={false}
                                        value={this.state.name}
                                        onChange={(name) => {
                                            if (typeof name === 'string' && name.length > 30) {
                                                return;
                                            }
                                            this.setState({ name }, function () {
                                                this.handleFilter()
                                            })
                                        }}
                                        data={(this.state.data) ? this.state.data.map(e => e.name) : []}
                                        messages={{
                                            emptyList: <Translation labelName="msg_there_r_no_items_list" defaultText="There are no items in this list"/> ,
                                          }}
                                    />
                                </div>
                                <div className="row epd-row-wrapper">
                                    <div className="col-md-12">
                                        <p className="bold-label"><Translation labelName="sub_title_low_epd" defaultText="Low EPD"/></p>
                                        <div className="row">
                                            <div className="epd-form-item">
                                                <FormItem label={<Translation labelName="lbl_original" defaultText="Original"/>}>
                                                    {getFieldDecorator('lowepdOrg', {
                                                        rules: [{ required: true, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/> },
                                                        { validator: this.validateInputFields, }],
                                                    })(
                                                        <InputNumber />
                                                    )}
                                                </FormItem>
                                            </div>
                                            <div className="epd-form-item">
                                                <FormItem
                                                    label={<Translation labelName="lbl_measured" defaultText="Measured"/>}>
                                                    {getFieldDecorator('lowepdMeasured', {
                                                        rules: [{ required: true, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/> },
                                                        { validator: this.validateInputFields, }],
                                                    })(
                                                        <InputNumber />
                                                    )}
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <p className="bold-label">{<Translation labelName="sub_title_high_epd" defaultText="High EPD"/>}</p>
                                        <div className="row">
                                            <div className="epd-form-item">
                                                <FormItem
                                                    label={<Translation labelName="lbl_original" defaultText="Original"/>}>
                                                    {getFieldDecorator('highepdOrg', {
                                                        rules: [{ required: true, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/> },
                                                        { validator: this.validateInputFields, }],
                                                    })(
                                                        <InputNumber

                                                        />
                                                    )}
                                                </FormItem>
                                            </div>
                                            <div className="epd-form-item">
                                                <FormItem
                                                    label={<Translation labelName="lbl_measured" defaultText="Measured"/>}>
                                                    {getFieldDecorator('highepdMeasured', {
                                                        rules: [{ required: true, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/>},
                                                        { validator: this.validateInputFields, }],
                                                    })(
                                                        <InputNumber

                                                        />
                                                    )}
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row epd-row-wrapper">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="epd-form-item">
                                                <FormItem
                                                    label={<Translation labelName="lbl_filter_length" defaultText="Filter Length"/>}>
                                                    {getFieldDecorator('filterlength', {
                                                        rules: [{ required: true, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/> },
                                                        { validator: this.validateInputFields, }],
                                                    })(
                                                        <InputNumber

                                                        />
                                                    )}
                                                </FormItem>
                                            </div>
                                            <div className="epd-form-item">
                                                <FormItem className="calculate">
                                                    <Button type="primary" className="btn btn-default" onClick={() => this.calcSlopeIntercept()}>{<Translation labelName="btn_calculate" defaultText="Calculate"/>}</Button>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="epd-form-item">
                                                <FormItem
                                                    label={<Translation labelName="lbl_Slope" defaultText="Slope"/>} className="bold-label">
                                                    <InputNumber disabled={true} value={this.state.slope} />
                                                </FormItem>
                                            </div>
                                            <div className="epd-form-item">
                                                <FormItem
                                                    label={<Translation labelName="lbl_lntercept" defaultText="Intercept"/>} className="bold-label">
                                                    <InputNumber disabled={true} value={this.state.intercept} />
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <a href='#' className='reset-preferences' onClick={(e) => this.reset(e)}>{<Translation labelName="btn_Reset_default" defaultText="Reset to Default"/>}</a>
                                <div className="reset-btn">
                                    <button
                                        type="submit"
                                        className="btn btn-default"
                                        onClick={(e) => this.handleSubmit(e)}>{<Translation labelName="btn_save" defaultText="Save"/>}</button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}
const DefaultEpd = Form.create()(Epd);

const mapStateToProps = ({ loggedUserState, filtersState }) => ({
    prefData: loggedUserState.prefData,
    epdData: filtersState.epdData
});

export default connect(mapStateToProps, null)(DefaultEpd);

Epd.propTypes = {
    form: PropTypes.object,
    showEpdScreen: PropTypes.func,
    isEpdVisible: PropTypes.bool,
    epdData: PropTypes.array,
    prefData: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Epd/index.js